import '.i{position:fixed;}.ssr-plugin'
import '.bi{top:0px;}.ssr-plugin'
import '.bo{left:0px;}.ssr-plugin'
import '.bp{right:0px;}.ssr-plugin'
import '.bq{bottom:0px;}.ssr-plugin'
import '.br{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.bs{z-index:998;}.ssr-plugin'
import '.bt{transition:opacity 0.3s ease;}.ssr-plugin'
import '.bu{height:100vh;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.a8{background-color:var(--palette-white);}.ssr-plugin'
import '.bv{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.bw{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.u{align-items:center;}.ssr-plugin'
import '.b8{justify-content:space-between;}.ssr-plugin'
import '.bx{padding:1.5rem;}.ssr-plugin'
import '.by{border-bottom:var(--border-default);}.ssr-plugin'
import '.ai{flex-shrink:0;}.ssr-plugin'
import '.az{flex:1;}.ssr-plugin'
import '.bz{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i bi bo bp bq br bs bt"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i bi bu n a8 bv bw d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d u b8 bx by ai"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="az bz bx"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
